module.exports = __webpack_public_path__ + "static/03-6654f20634805db927e14373d9efa9a5.png";